import * as React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";
// component
import Icon from "common/icons";
import SolidButton from "common/components/solidButton";
// helpers
import { isBrowser } from "@vingle/wtf-sdk/helpers/envChecker";
import * as FacebookSDK from "@vingle/wtf-sdk/helpers/facebook";
import { VingleURL } from "@vingle/wtf-sdk/url";
// constant
import {
  BG_URLS,
  COMMENTS_LENGTH,
  BG_URLS_LENGTH,
} from "app/signUp/entrance/constants";
// style
const styles = require("./signUpComponent.scss");

interface IProps
  extends RouteComponentProps<Vingle.IMatchParams>,
    WrappedComponentProps {
  trySignInWithFB: () => void;
}

interface IState {
  currentCommentPosition: number;
  currentBackgroundImagePosition: number;
}

const backgroundURLs: string[] = [...BG_URLS].sort(() =>
  Math.random() > 0.5 ? 1 : -1,
);

class SignUpEntranceComponent extends React.PureComponent<IProps, IState> {
  public state = {
    currentCommentPosition: 1,
    currentBackgroundImagePosition: 1,
  };
  private commentChangeEvent: any;
  private backgroundImageChangeEvent: any;

  public componentDidMount() {
    const safeCommentInterval = 3000;
    const safeBGInterval = 6000;

    this.commentChangeEvent = setInterval(() => {
      this.changeComment();
    }, safeCommentInterval);
    this.backgroundImageChangeEvent = setInterval(() => {
      this.changeBackgroundImage();
    }, safeBGInterval);
  }

  public componentWillUnmount() {
    clearInterval(this.commentChangeEvent);
    clearInterval(this.backgroundImageChangeEvent);
  }

  public render() {
    const { intl, location } = this.props;
    const {
      currentCommentPosition,
      currentBackgroundImagePosition,
    } = this.state;

    const redirectUrl = isBrowser()
      ? `${location.pathname}?${location.search}`
      : "";

    const comment = intl.formatMessage(
      { id: `signup.comment_${currentCommentPosition}` },
      {
        title: (msg: string) => <div className={styles.title}>{msg}</div>,
        small: (msg: string) => <div className={styles.small}>{msg}</div>,
        subtitle: (msg: string) => <div className={styles.subTitle}>{msg}</div>,
        b: (msg: string) => <b>{msg}</b>,
      },
    );

    const backgroundImageNodes = backgroundURLs.map((url, index) => {
      if (currentBackgroundImagePosition === index + 1) {
        return (
          <div
            key={`signUpEntranceBg_${index}`}
            className={styles.backgroundImage}
            style={{
              opacity: 1,
              visibility: "visible",
              backgroundImage: `url(${url})`,
              backgroundSize: "cover",
            }}
          />
        );
      }
      return (
        <div
          key={`signUpEntranceBg_${index}`}
          className={styles.backgroundImage}
          style={{
            opacity: 0,
            backgroundImage: `url(${url})`,
            backgroundSize: "cover",
          }}
        />
      );
    });

    return (
      <div className={styles.bodyWrapper}>
        <div className={styles.backgroundImagesWrapper}>
          {backgroundImageNodes}
        </div>
        <div className={styles.container}>
          <div className={styles.logo}>
            <Icon icon="SIGNUP_LOGO" />
          </div>
          <div className={styles.comment}>{comment}</div>
        </div>
        <div className={styles.footer}>
          <SolidButton
            buttonText={intl.formatMessage({ id: "signup.with_facebook" })}
            disabled={false}
            className={styles.btnFB}
            onClick={this.facebookSignUp}
          />
          <SolidButton
            buttonText={intl.formatMessage({ id: "signup.with_email" })}
            disabled={false}
            className={styles.btnEmail}
            onClick={this.emailSignUp}
          />
          <div className={styles.hadAccount}>
            <FormattedMessage id="signup.already_have_account" />
            <span className={styles.login}>
              <Link
                to={new VingleURL.SignIn().toLocation({
                  query: {
                    redirect_url: redirectUrl,
                  },
                })}
              >
                <FormattedMessage id="log_in" />
              </Link>
            </span>
          </div>
        </div>
      </div>
    );
  }

  private readonly changeComment = () => {
    this.setState(state => {
      return {
        currentCommentPosition:
          state.currentCommentPosition + 1 > COMMENTS_LENGTH
            ? 1
            : state.currentCommentPosition + 1,
      };
    });
  };

  private readonly changeBackgroundImage = () => {
    this.setState(state => {
      return {
        currentBackgroundImagePosition:
          state.currentBackgroundImagePosition + 1 > BG_URLS_LENGTH
            ? 1
            : state.currentBackgroundImagePosition + 1,
      };
    });
  };

  private readonly facebookSignUp = async () => {
    const { trySignInWithFB, history } = this.props;

    if (isBrowser()) {
      const response = await FacebookSDK.login({
        scope: "email",
        auth_type: "rerequest",
      });

      switch (response.status) {
        case "connected": {
          try {
            await trySignInWithFB();
            window.location.href = new VingleURL.Home().toString();
          } catch (err) {
            history.push(
              new VingleURL.SignUpDetail({
                signType: "facebook",
              }).toString(),
            );
          }
          break;
        }
      }
    }
  };

  private readonly emailSignUp = () => {
    const { history } = this.props;

    history.push(
      new VingleURL.SignUpDetail({
        signType: "email",
      }).toString(),
    );
  };
}

export default withRouter(injectIntl(SignUpEntranceComponent));
